import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import Icon from 'src/components/Icon/Icon';
import { Amount } from 'src_common/common/amount/Amount';

class AuditDetailsBets extends React.Component {
    static propTypes = {
        audits: PropTypes.object
    };

    renderEventDetailsTableRow(audits, toExclude, levelKey = [], styleClassNeme = 'none') {
        const keyArr = [...levelKey];
        const keysToConvert = ['payout', 'operatorPayout', 'totalStake', 'stakePerLine', 'operatorStakePerLine', 'operatorTotalStake', 'maxBet', 'potentialReturns', 'profit', 'operatorProfit'];

        const isFreebet = get( this.props.audits, 'body.bet.freebet' );
        const currency = 'GBP';

        return Object.keys(audits).map((key) => {
            const gitftIcon = [ 'freebet', 'totalStake' ].includes( key ) && isFreebet ? <Icon name='gift'/> : void 0;

            if (toExclude.includes(key) === false) {

                if (audits[key] !== null && audits[key].constructor === Object) {
                    keyArr.push(key);

                    return this.renderEventDetailsTableRow(audits[key], toExclude, keyArr, styleClassNeme);

                }

                if (audits[key] !== null && audits[key].constructor === Array) {
                    return (
                        <tr className={styleClassNeme}>
                            <td>{key.charAt(0).toUpperCase() + key.slice(1)}</td>
                            <td>
                                {audits[key].map((audit, keyArr) => JSON.stringify(audit).replace(/"/g, ' ') + ( keyArr != audits[key].length - 1 ? ', ' : '' )) }
                                { gitftIcon }
                            </td>
                        </tr>
                    );
                }

                audits[key] = keysToConvert.includes(key) && audits[key] !== null ? new Amount(audits[key]).format(currency, {withoutCurrencySymbol: true}) : audits[key] === null ? 'n/a' : audits[key];

                const renderKey = keyArr.join('.');
                return (
                    <tr className={styleClassNeme} key={key}>
                        { keyArr.length > 0 ?
                            <td>{ renderKey.charAt(0).toUpperCase() + renderKey.slice(1) + '.' + key }</td> :
                            <td>{ key.charAt(0).toUpperCase() + key.slice(1) }</td> }
                        <td>
                            { (typeof(audits[key]) === 'string' || audits[key] === null) ? audits[key] : JSON.stringify(audits[key]) }
                            { gitftIcon }
                        </td>
                    </tr>
                );
            }
        });
    }

    renderEventDetailsTable() {
        const {audits, id} = this.props;
        const toExclude = ['legs', 'body'];

        const eventType = id.split('_');
        const eventArr = eventType[eventType.length - 1].split('-');
        for (let i = 0; i < toExclude.length; i++) {
            if (eventArr[0].includes(toExclude[i].slice(0, 5))) {
                toExclude.splice(i, 1);
            }
        }

        return (
            <table>
                <thead>
                    <tr>
                        <td>
                            <strong>
                                {eventArr[0].charAt(0).toUpperCase() + eventArr[0].slice(1) + ' ' + eventArr[1].charAt(0).toUpperCase() + eventArr[1].slice(1) }
                            </strong>
                        </td>
                        <td>
                            <strong>
                            Value
                            </strong>
                        </td>
                    </tr>
                </thead>
                <tbody>
                    { this.renderEventDetailsTableRow(audits.body, toExclude) }

                    <tr>
                        <td></td>
                        <td></td>
                    </tr>
                    <tr>
                        <td></td>
                        <td></td>
                    </tr>
                    { this.renderEventDetailsTableRow(audits, toExclude, [] , 'technical-details') }
                </tbody>
            </table>
        );
    }

    render() {
        return (
            <div className='audit-details-bets'>
                { this.renderEventDetailsTable() }
            </div>
        );
    }
}

export default AuditDetailsBets;
